// extracted by mini-css-extract-plugin
export default {"mainCont":"Dashboard_mainCont__r9Q4Y","head":"Dashboard_head__X2BnS","brdr":"Dashboard_brdr__Y-189","cardCont":"Dashboard_cardCont__oNXBu","cardBox":"Dashboard_cardBox__FRy10"};